import { PromosToolbar } from 'www/articles/promos-articles/modules/common/toolbar/promos-toolbar';
import { PromosShareWidget } from 'www/articles/promos-articles/modules/common/toolbar/share-widget/promos-share-widget';
import { RecapShareLayer } from './share-widget/recap-share-layer';
let commentsWidgetApi = null;

export class ReCapToolbar extends PromosToolbar{
	constructor(el){
		super(el);
	}

	init(){
		this.initComments();
		this.initShare();
		$(document).ready(()=>{
			this.initEmailAlerts();
		})
	}
	initShare(){
		let shareWidget = new PromosShareWidget();
		shareWidget.TooltipLayer = RecapShareLayer;
		this.el.appendChild(shareWidget.el);
		shareWidget.init();
		this.WidgetsMap.set("share",shareWidget);
	}
}

